import { memo } from 'react';

function HealthShieldIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M11.389 13.333H8.61V11.39H6.667V8.61H8.61V6.666h2.778v1.945h1.944v2.778H11.39v1.944z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M4.167 15L2.63 4.246a.996.996 0 01.774-1.114l6.162-1.37a2 2 0 01.868 0l6.162 1.37c.51.114.848.597.774 1.114L15.833 15c-.059.412-.416 2.916-5.833 2.916S4.226 15.412 4.167 15z"
      ></path>
    </svg>
  );
}

export default memo(HealthShieldIcon);
